import { useEffect, useState } from 'react';
export function useScrollDirection(threshold = 10, disabled = false) {
    const [state, setState] = useState('down');
    useEffect(() => {
        if (disabled)
            return;
        let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
        let timerId = null;
        const handleUpdate = () => {
            timerId = null;
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (Math.abs(lastScroll - currentScroll) > threshold) {
                const delta = currentScroll - lastScroll;
                lastScroll = currentScroll;
                setState(delta > 0 ? 'down' : 'up');
            }
        };
        const handleScroll = () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            timerId = requestAnimationFrame(handleUpdate);
        };
        document.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            if (timerId != null) {
                cancelAnimationFrame(timerId);
            }
            document.removeEventListener('scroll', handleScroll);
        };
    }, [disabled, threshold]);
    return state;
}
//# sourceMappingURL=useScrollDirection.js.map